import React from 'react';
import styled from "styled-components";
import loadmore from "../assets/loadmore.png";
import { useScroll } from "./useScroll";


function Portfolio() {
  const [element, controls] = useScroll();
  return (
  <Section id="portfolio" ref={element}>
    <div className="portfolio-more">
        <p >  料金プラン </p>
        <span>店舗様のニーズに合わせて、ご提案させて頂きます。</span>
<span>詳しくはお問い合わせください</span>
      

        <img src={loadmore} alt="Load More" />
    </div>
  </Section>
  );
}

const Section = styled.section`
min-height: 20vh;
padding-bottom: 2rem;
background-color: var(--primary-color);

.portfolio-more {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  margin: 4rem 0;
  span {
    font-size: 20px;
    color: #fff;
    letter-spacing: 0.1rem;
    text-transform: uppercase;
    margin-top: 4rem;
  }
  p{
    margin-top: 4rem;
    font-size: 30px;
    color: #fff;
  }
}
@media screen and (min-width: 280px) and (max-width: 1080px) { 

 
  .portfolio-more {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    margin: 4rem 0;
    span {
      font-size: 12px;
      color: #fff;
      letter-spacing: 0.1rem;
      text-transform: uppercase;
      margin-top: 2rem;
    }
    p{
        margin-top: 4rem;
        font-size: 30px;
        color: #fff;
      }
  }
}
`;

export default Portfolio
